<template>
  <div class="Sidebar">
    <div class="Sidebar__title">Üyelik İşlemleri</div>
    <div class="Sidebar__links">
      <router-link to="/bagislarim" tag="div" class="Sidebar__links--link">
        <i class="fas fa-hand-holding-heart icon"></i>
        <span>Bağışlarım</span>
      </router-link>
      <router-link to="/ayarlar" tag="div" class="Sidebar__links--link">
        <i class="fas fa-cog icon"></i>
        <span>Ayarlar</span>
      </router-link>
      <button @click="handleLogout" style="border: none" class="Sidebar__links--link">
        <i class="fas fa-sign-out-alt icon"></i>
        <span>Çıkış</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  methods: {
    ...mapMutations(['logout']),
    handleLogout() {
      this.logout()
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
